import React from 'react'; // eslint-disable-line
import { render } from 'preact';
import axios from 'axios';
import { createPosts } from './';

class Base extends React.Component {
  static create() {
    const node = document.querySelector('.js-intranet-news');
    if (!node) return;

    render(
      <Base />,
      node,
    );
  }

  state = {
    posts: this.props.posts || [],
    hasNext: true,
    isLoading: true,
  }

  componentDidMount() {
    this.getPosts(this.page || 0);
  }

  getPosts(page) {
    this.setState({ isLoading: true });
    axios(`/wp-json/app/v1/news/?page=${page}`)
      .then(({ data }) => {
        if (!data) return;
        const posts = createPosts(data);
        if (!posts || !Array.isArray(posts)) return;
        const hasNext = data.has_next;
        this.page += 1;
        this.setState({
          posts: [...this.state.posts, posts],
          isLoading: false,
          hasNext,
        });
      });
  }

  page = 1;

  handleClick = (e) => {
    e.preventDefault();
    this.getPosts(this.page);
  }

  render() {
    if (!this.state.posts || this.state.posts.length < 1) return null;
    return (
      <div>
        {this.state.posts}
        <div className="intraNews__button">
          <button
            disabled={!this.state.hasNext}
            className="intraButton"
            onClick={this.handleClick}
          >
            Visa äldre inlägg
          </button>
        </div>
        {this.state.isLoading &&
          <span className="intraNews__loader">
            Laddar fler inlägg...
          </span>}
        {!this.state.hasNext &&
          <span className="intraNews__loader">
            Inga fler inlägg att visa
          </span>}
      </div>
    );
  }
}

export default Base;



// WEBPACK FOOTER //
// ./components/Intranet/News/Base.js